import { Supports } from './Supports';
import { SupportEdit } from './SupportEdit';

export {
    Supports,
    SupportEdit
};



// WEBPACK FOOTER //
// ./src/views/Supports/index.js